import styled from 'styled-components';

const Content = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  gap: 5px;
  margin-top: 10px;
`;

export default Content;
